export const STRING = 'DT_STRING';
export const NUMBER = 'DT_NUMBER';
export const DATE = 'DT_DATE';
export const TIME = 'DT_TIME';
export const BOOL = 'DT_BOOL';
export const TABLE = 'DT_TABLE';
export const HTML = 'DT_HTML';

export const MANAGER_TAB = 'MANAGER_TAB';
export const EMPLOYEE_TAB = 'EMPLOYEE_TAB';



// WEBPACK FOOTER //
// ./src/constants/DataTypes.js